import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const transparentImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNgYAAAAAMAASsJTYQAAAAASUVORK5ErkJggg=";

function FollowInsta({ImageUrls,VideoUrls,LinkUrls}) {

  let imageItemUrls = ImageUrls
  let videoItemUrls = VideoUrls
  let linkItemUrls = LinkUrls

  const instagramVideos = [
    {
      id: 1,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image9.url,
      videoalt:"Play Video 1", // Changed to a more descriptive alt text
      alt: imageItemUrls.image9.altText
    },
    {
      id: 2,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image9.url,
      alt: imageItemUrls.image9.altText,
      videoalt:"Play Video 2", // Changed to a more descriptive alt text

    },
    {
      id: 3,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image10.url,
      alt: imageItemUrls.image10.altText,
      videoalt:"Play Video 3", // Changed to a more descriptive alt text

    },
    {
      id: 4,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image11.url,
      alt: imageItemUrls.image11.altText,
      videoalt:"Play Video 4", // Changed to a more descriptive alt text

    },
    {
      id: 5,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image12.url,
      videoalt:"Play Video 5", // Changed to a more descriptive alt text
      alt: imageItemUrls.image12.altText,
    },
    {
      id: 6,
      videoUrl: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
      thumbnailUrl: imageItemUrls.image13.url,
      alt: imageItemUrls.image14.altText ,
      videoalt:"Play Video 6", // Changed to a more descriptive alt text
      // Corrected this to image13.altText if that's what you intended, or keep image14.altText if it's intentional.
    }
  ];

  const handleVideoClick = (videoUrl) => {
    window.open(videoUrl, '_blank');
  };

  const containerRef = useRef(null);
  const headerBarRef = useRef(null);
  const videosContainerRef = useRef(null);
  const videoItemRefs = useRef([]); // To hold refs for individual video items

  useEffect(() => {
    const container = containerRef.current;
    const headerBar = headerBarRef.current;
    const videosContainer = videosContainerRef.current;
    const videoItems = videoItemRefs.current;

    // Animation for the header bar
    gsap.fromTo(headerBar,
      { opacity: 0, y: -50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      }
    );

    // Animation for the videos container
    gsap.fromTo(videosContainer,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 70%',
          toggleActions: 'play none none none',
        },
      }
    );

    // Staggered animation for individual video items
    gsap.fromTo(videoItems,
      { opacity: 0, scale: 0.8 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: 'back.out(1.7)',
        stagger: 0.1,
        scrollTrigger: {
          trigger: videosContainer,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      }
    );

  }, []);

  return (
    <>
      <style jsx>{`
        .insta-container {
          background-color: white;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .header-bar {
          background-color: #808080;
          width: 100%;
          padding: 20px 0;
          text-align: center;
          position: relative;
        }

        .header-text {
          color: white;
          font-size: 24px;
          margin: 0;
          font-family: 'Arial', sans-serif;
          font-weight: bold;
          letter-spacing: 1px;
        }

        .videos-container {
          display: flex;
          justify-content: flex-start;
          flex-wrap: nowrap;
          gap: 20px;
          padding: 40px 20px;
          max-width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
          scrollbar-color: #888 #f1f1f1;
        }

        .videos-container::-webkit-scrollbar {
          height: 8px;
        }

        .videos-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .videos-container::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }

        .videos-container::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        .video-item-group {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        .video-thumbnail {
          width: 200px;
          height: 200px;
          background-color: #ccc;
          background-size: cover;
          background-position: center;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .video-thumbnail:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .horizontal-track {
          display: flex;
          align-items: center;
          width: 100%;
          margin-top: -35px;
          position: relative;
          z-index: 1;
        }

        .track-line {
          flex-grow: 1;
          height: 8px;
          background-color: black;
        }

        .track-circle {
          width: 45px;
          height: 45px;
          border: 8px solid black;
          border-radius: 50%;
          background-color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          margin: 0 -4px;
          position: relative;
          z-index: 2;
        }

        .play-button-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 35px;
          height: 35px;
          background-color: black;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          z-index: 3;
          box-shadow: none;
          transition: transform 0.3s ease; /* Added transition for hover effect */
        }

        .play-button-container:hover {
          background-color: black;
          transform: translate(-50%, -50%) scale(1.05);
        }

        .play-icon {
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 15px solid white;
          margin-left: 4px;
        }

        .transparent-alt-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          opacity: 0;
        }

        /* Media Queries */
 @media (max-width: 1100px) {
          .videos-container {
            gap: 15px;
            padding: 30px 15px;
            flex-direction: column;
            align-items: center; /* Center items in column layout */
          }
              .header-text {
            font-size: 18px;
            padding: 0 10px;
          }

          .video-thumbnail {
            width: 350px;
            height: 350px;
          }

          .play-button-container {
            width: 40px;
            height: 40px;
          }
          .play-icon {
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid white;
            margin-left: 3px;
          }
        }
        /* For screens up to 1000px (e.g., larger tablets, smaller desktops) */
        @media (max-width: 1000px) {
          .videos-container {
            gap: 15px;
            padding: 30px 15px;
            flex-direction: column;
            align-items: center; /* Center items in column layout */
          }
              .header-text {
            font-size: 18px;
            padding: 0 10px;
          }

          .video-thumbnail {
            width: 350px;
            height: 350px;
          }

          .play-button-container {
            width: 40px;
            height: 40px;
          }
          .play-icon {
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid white;
            margin-left: 3px;
          }
        }

        /* For screens up to 900px (e.g., tablets in landscape) */
        @media (max-width: 900px) {
          .videos-container {
            gap: 15px;
            padding: 30px 15px;
            flex-direction: column;
            align-items: center; /* Center items in column layout */
          }
              .header-text {
            font-size: 18px;
            padding: 0 10px;
          }

          .video-thumbnail {
            width: 350px;
            height: 350px;
          }

          .play-button-container {
            width: 40px;
            height: 40px;
          }
          .play-icon {
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid white;
            margin-left: 3px;
          }
        }

        /* For screens up to 768px (e.g., tablets in portrait) */
        @media (max-width: 768px) {
          .header-text {
            font-size: 18px;
            padding: 0 10px;
          }

          .video-thumbnail {
            width: 350px;
            height: 350px;
          }

          .play-button-container {
            width: 40px;
            height: 40px;
          }
          .play-icon {
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid white;
            margin-left: 3px;
          }
        }

       

        /* For screens up to 480px (e.g., smaller mobile devices) */
        @media (max-width: 480px) {
          .video-thumbnail {
            width: 230px;
            height: 230px;
          }
        }
      `}</style>

      <div className="insta-container" ref={containerRef}>
        <div className="header-bar" ref={headerBarRef}>
          <p className="header-text">
            FOLLOW US ON INSTAGRAM: <a href={linkItemUrls.link1.url} style={{ color: 'white', textDecoration: 'none' }} aria-label={linkItemUrls.link1.altText}>@_ABCD_STUDIO</a>
          </p>
        </div>

        <div className="videos-container" ref={videosContainerRef}>
          {instagramVideos.map((video, index) => (
            <div key={video.id} className="video-item-group" ref={el => (videoItemRefs.current[index] = el)}>
              <a href={video.videoUrl} target="_blank" rel="noopener noreferrer" aria-label={video.alt}>
                <div
                  className="video-thumbnail"
                  style={{ backgroundImage: `url(${video.thumbnailUrl})` }}
                >
                  <img
                    src={transparentImage}
                    alt={video.alt}
                    className="transparent-alt-image"
                  />
                </div>
              </a>

              <div className="horizontal-track">
                <div className="track-line"></div>
                <div className="track-circle">
                  <div
                    className="play-button-container"
                    onClick={() => handleVideoClick(video.videoUrl)}
                    aria-label={video.videoalt}
                  >
                    <img
                      src={transparentImage}
                      alt={video.videoalt}
                      className="transparent-alt-image"
                    />
                    <div className="play-icon"></div>
                  </div>
                </div>
                <div className="track-line"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default FollowInsta;